import React from 'react';
import { FormattedMessage } from 'react-intl';
import core from '@gin-betting/core';
import { capitalize } from 'lodash';

import { LiveLabel, MatchTime } from 'components';
import globalMessages from 'messages';

import './dateTime.scss';

const {
    utils: { formatTimeAndDate },
} = core;

interface Props {
    startTime: string;
    isLive: boolean;
    matchId: string;
}

const DateTime: React.FC<Props> = ({ startTime, isLive, matchId }) => {
    const { isToday, date, time } = formatTimeAndDate(startTime);

    return (
        <React.Fragment>
            <LiveLabel isFaded={!isLive} />

            <div styleName="wrapper">
                {isLive ? (
                    <MatchTime matchId={matchId} />
                ) : (
                    <React.Fragment>
                        <div styleName="time">
                            {isToday ? time : capitalize(date)}
                        </div>
                        <div styleName="date">
                            {isToday ? (
                                <FormattedMessage
                                    {...globalMessages.todayText}
                                />
                            ) : (
                                time
                            )}
                        </div>
                    </React.Fragment>
                )}
            </div>
        </React.Fragment>
    );
};

export default DateTime;
